import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TOATimelineReelsController} from "../reel/TOATimelineReelsController";
import {TombOfAkhenaten} from "../TombOfAkhenaten";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SoundManager} from "../sound/SoundManager";
import {TombOfAkhenatenSoundConfig} from "../TombOfAkhenatenSoundConfig";


export class SpinningPyramid extends PIXI.Container {
    stagger?: number;
    private readonly _index: number;
    private _pyramid: PIXI.Sprite;
    private _hotZone: PIXI.Sprite;
    private _tl: TimelineLite;
    private _isHit: boolean = false;
    private _wildAnticipation: TimelineSprite;
    public static durationPerDeg: number = 0.0009;//0.0015 ;
    public static STOP_INTERVAL: number = 1.125; //600ms
    public _isPlaying: boolean = false;
    private _pyramidGlow: PIXI.Sprite;
    private _ringShine: PIXI.Sprite;
    private _pyramidShine: PIXI.Sprite;
    private _hotZoneGlow: PIXI.Sprite;
    private _circleShine: PIXI.Sprite;
    private _skyGlow: PIXI.Sprite;
    private _hotZoneBlast: TimelineSprite;
    public _isLast: boolean = false;
    private _ring: PIXI.Sprite;
    private _sky: PIXI.Sprite;
    public static pyramidReelLand: boolean[] = [];
    private _isCycleComplete: boolean = true;
    public static reelFireFrameArr: Map<number, any[]> = new Map<number, TimelineSprite[]>();
    private _blinkFrameArr: PIXI.Sprite[] = [];
    public _nonWinSymBlinkTl: TimelineLite;

    constructor(index: number, stagger?: number) {
        super();
        this._index = index;
        this.addEventListener();
        this.stagger = stagger || 0;
    }

    private createSprite(resourceName: string, isShow: boolean = false): PIXI.Sprite {
        const sprite: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(resourceName)[0]);
        sprite.anchor.set(0.5);
        sprite.alpha = isShow ? 1 : 0;
        return sprite;
    }

    init() {
        const layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.STONE_PRESSER.name);
        layer.addChild(this);
        this.name = "SPINNING_PYRAMID_" + this._index;


        const shadow: PIXI.Sprite = this.createSprite("shadow", true);
        const ring: PIXI.Sprite = this.createSprite("ring", true);
        const ringShine: PIXI.Sprite = this.createSprite("ringShine");
        const sky: PIXI.Sprite = this.createSprite("sky", true);
        const skyGlow: PIXI.Sprite = this.createSprite("skyGlow", true);
        const pyramid: PIXI.Sprite = this.createSprite("pyramid", true);
        const pyramidShine: PIXI.Sprite = this.createSprite("pyramidShine");

        const hotZone: PIXI.Sprite = this.createSprite("hotZone", true);
        const pyramidGlow: PIXI.Sprite = this.createSprite("pyramidGlow");
        const hotZoneGlow: PIXI.Sprite = this.createSprite("hotZoneGlow");
        const circleShine: PIXI.Sprite = this.createSprite("pyramidCircleShine");

        const hotZoneBlast = new TimelineSprite(GameResources.getTextures("hotZoneBlast"));
        hotZoneBlast.blendMode = PIXI.BLEND_MODES.ADD;
        skyGlow.blendMode = PIXI.BLEND_MODES.ADD;
        hotZoneBlast.anchor.set(0.5);
        hotZoneBlast.hide();

        shadow.position.y = 10;
        this.addChild(shadow, ring, ringShine, sky, skyGlow, pyramid, pyramidGlow, pyramidShine, hotZone, hotZoneGlow, hotZoneBlast, circleShine);

        hotZone.angle = 0;
        const reelId: number = this._index * 5;
        const pos: number[] = TombOfAkhenatenGameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        this.position.set(pos[0], 88);
        this._pyramid = pyramid;
        this._hotZone = hotZone;
        this._hotZoneGlow = hotZoneGlow;
        this._pyramidGlow = pyramidGlow;
        this._ringShine = ringShine;
        this._pyramidShine = pyramidShine;
        this._circleShine = circleShine;
        this._skyGlow = skyGlow;
        this._hotZoneBlast = hotZoneBlast;
        this._ring = ring;
        this._sky = sky;

        this._wildAnticipation = new TimelineSprite(GameResources.getTextures("fullReelPyramidAnticipation"));
        this._wildAnticipation.anchor.set(0.5, 0);
        this._wildAnticipation.blendMode = PIXI.BLEND_MODES.ADD;
        this._wildAnticipation.hide();
        this._wildAnticipation.pivot.y = 30;
        this.addChild(this._wildAnticipation);
        circleShine.blendMode = PIXI.BLEND_MODES.ADD;
        this.hide();
    }

    private addEventListener() {
        EventHandler.addEventListener(this, TOAGameEvent.PYRAMID_EXPANDING_WILD_ANIM_COMPLETE, (event: GameEvent) => {
            if (event.params[0] == this._index) {
            }
        });
        EventHandler.addEventListener(this, TOAGameEvent.PYRAMID_X2_BLAST_ANIM, (event: GameEvent) => {
            if (event.params[0] == this._index) {
                this.playX2BlastAnim();
            }
        });
    }

    onNewGameRound() {
        this.hide();
        this._blinkFrameArr.length = 0;
    }

    onGameDataParsed(data: TombOfAkhenatenParsedGameData) {
        this._isHit = data.pyramidReelLand[this._index];
        SpinningPyramid.pyramidReelLand = data.pyramidReelLand;
    }

    private onUpdate() {
        this._hotZoneGlow.angle = this._hotZone.angle;
        if ((this._hotZone.angle % 360 > 340 || this._hotZone.angle % 360 < 20) && this._isCycleComplete) {
            this._isCycleComplete = false;
            this._pyramidGlow.alpha = 1;
            this._hotZoneGlow.alpha = 1;
            //this.playReelFrameBlinkAnticipation(this._index, true);
        } else if (!this._isCycleComplete) {
            this._isCycleComplete = true;
            this._pyramidGlow.alpha = 0;
            this._hotZoneGlow.alpha = 0;
            //this.playReelFrameBlinkAnticipation(this._index, false);
        }

    }

    play(): TimelineLite {
        if (this._tl?.isActive()) {
            this._tl.pause().kill();
        }
        this._tl = new TimelineLite();
        const defaultDeg: number = 360 * 10000;
        this._tl.add(() => this.playStartAnimation());
        this._tl.add(TweenLite.to(this._hotZone, defaultDeg * SpinningPyramid.durationPerDeg, {
            angle: defaultDeg,
            ease: Linear.easeNone,
        }));
        this._isPlaying = true;
        //
        return this._tl;
    }


    public stop() {
        if (this._tl?.isActive()) {
            this._tl.pause().kill();
        }
        this._tl = new TimelineLite();
        const defaultRotation: number = this._hotZone.angle;
        const reminderRotation = 360 - defaultRotation % 360;
        let additionalRotation = 0;
        if (this._isHit) {
            additionalRotation = reminderRotation + 360;//(this._isHit ? reminderRotation : reminderRotation + (Math.random() * 240 + 60)); //random between 60-300
        } else {
            //additionalRotation = reminderRotation > 180 ? reminderRotation - 30 : reminderRotation + 30;
            additionalRotation = reminderRotation + (Math.random() * 240 + 60);
        }
        const deg = defaultRotation + additionalRotation; //random between 30-300
        const duration = 1.5;// additionalRotation * SpinningPyramid.durationPerDeg + 0.2;// degree per nanosecond;//slow down speed

        this._tl.add(TweenLite.to(this._hotZone, duration, {
            angle: deg,
            //ease: Linear.easeNone,
            ease: "sine.out",
            //ease: "slow(0.8.5, 0.7, true)",
            onUpdate: () => this.onUpdate()
        }));
        this._tl.add(() => {
            //this.playNonWinSymBlink(true); //now its automatically end in between 1.5s
            this.stopBgCircleShine();
            this._isLast && TombOfAkhenatenGameModuleConfig.spinningPyramidController.stopSpinningSound();
        })
        if (this._isHit) {
            this._tl.add(() => this.playLockSound());
            this._tl.add([
                this.playHitAnimation(),
                this.playWildAnticipation()
            ], "+=0.0603"); //0.5 total duration
            //this._tl.add(this.playWildAnticipation(), "+=0.1"); //00.633 total duration
        } else {
            this._tl.add(() => this.playLostAnimation());
            //this._tl.add(TweenLite.to({}, 0.1, {})); //0.1 lost animation delay
        }

        this._tl.add(() => {
            this._isPlaying = false;
            EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_PYRAMID_SPINNING_STOPPED, this._index));
        });
    }

    private playLostAnimation() {
        this.playStopSpinSound();
        this._pyramid.tint = 0xadadad;
        this._hotZone.tint = 0xadadad;
        this._ring.tint = 0xadadad;
        this._sky.tint = 0xadadad;
        TweenLite.to(this, 1, {alpha: 0});
    }

    public playBgCircleShine() {
        this.playGlowStartSound();
        TweenLite.to(this._circleShine, 0.2, {alpha: 0.4});
    }

    public stopBgCircleShine() {
        TweenLite.to(this._circleShine, 0.1, {alpha: 0});
    }

    private playGlowStartSound(){
        //Logger.logDev("sounds new1 playGlowStartSound");
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_START_SPIN);
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_START_SPIN);
    }
    private playStopSpinSound(){
        this.stopStopSpinSound();
        //Logger.logDev("sounds new1 playStopSpinSound");
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_STOP_SPIN);
    }
    private stopStopSpinSound(){
        //Logger.logDev("sounds new1 stopStopSpinSound");
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_STOP_SPIN);
    }

    private playStartAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_PYRAMID_SPINNING_STARTED, this._index)),
            TweenLite.to(this._pyramidShine, 0.1, {alpha: 1}),
            TweenLite.to(this._pyramidGlow, 0.1, {alpha: 1}),
            //TweenLite.to(this._ringShine, 0.1, {alpha: 1}),
            TweenLite.to(this._skyGlow, 0.1, {alpha: 1})
        ]);
        tl.add([
            TweenLite.to(this._pyramidShine, 0.1, {alpha: 0}),
            TweenLite.to(this._pyramidGlow, 0.1, {alpha: 0}),
            //TweenLite.to(this._ringShine, 0.1, {alpha: 0}),
            TweenLite.to(this._skyGlow, 0.1, {alpha: 0})
        ]);
        return tl;
    }

    private playHitAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            () => {
                TweenLite.to(this._hotZoneBlast.scale, 0.2, {x: 2, y: 2});
                this._hotZoneBlast.getAnimationAutoShowHide(true, true);
            },
            TweenLite.to(this._circleShine, 0.2, {alpha: 1}),
        ]);
        tl.add([
            TweenLite.to(this._circleShine, 0.3, {alpha: 0})
        ]);
        tl.add([
            //() => this.playBlinkShine(),//As per new suggestion
            TweenLite.to(this._pyramidShine, 0.2, {alpha: 1}),
            TweenLite.to(this._ringShine, 0.2, {alpha: 1}),
            TweenLite.to(this._pyramidGlow, 0.1, {alpha: 1}),
            TweenLite.to(this._hotZoneGlow, 0.1, {alpha: 1}),
        ]);
        return tl;
    }

    private playX2BlastAnim() {
        TweenLite.to(this._hotZoneBlast.scale, 0.2, {x: 2, y: 2});
        this._hotZoneBlast.getAnimationAutoShowHide(true, true);
    }

    private addReelFrameFire(reelId: number): TimelineLite {
        const layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name);
        const tlReelController = (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController);
        const tl: TimelineLite = new TimelineLite();
        if (!tlReelController._stickySymArr[reelId]) {
            const pos: number[] = this.getSymPos(reelId);
            const anticipationBlast = new TimelineSprite(GameResources.getTextures("anticipationBlast"));
            anticipationBlast.blendMode = PIXI.BLEND_MODES.ADD;
            const loopFireAnticipation = new TimelineSprite(GameResources.getTextures("loopFireAnticipation"));
            const finalPyramidAnticipationFrame = new TimelineSprite(GameResources.getTextures("finalPyramidAnticipationFrame"));
            finalPyramidAnticipationFrame.blendMode = PIXI.BLEND_MODES.ADD;
            layer.addChild(loopFireAnticipation, anticipationBlast, finalPyramidAnticipationFrame);
            anticipationBlast.position.set(pos[0], pos[1] - 33);
            loopFireAnticipation.position.set(pos[0], pos[1] - 33);
            finalPyramidAnticipationFrame.position.set(pos[0], pos[1] - 33);
            finalPyramidAnticipationFrame.anchor.set(0.5);
            anticipationBlast.anchor.set(0.5);
            loopFireAnticipation.anchor.set(0.5);
            loopFireAnticipation.hide();
            anticipationBlast.hide();
            finalPyramidAnticipationFrame.hide();
            loopFireAnticipation.blendMode = PIXI.BLEND_MODES.ADD;
            tl.add([
                anticipationBlast.getAnimationAutoShowHide(true, true),
                TweenLite.to({}, 0.2, {
                    onComplete: () => {
                        loopFireAnticipation.show();
                        loopFireAnticipation.playLoop();
                    }
                }),

            ]);
            SpinningPyramid.reelFireFrameArr.set(reelId, [loopFireAnticipation, anticipationBlast, finalPyramidAnticipationFrame]);
        }
        return tl;
    }

    private getSymPos(reelId: number): number[] {
        const sym = Reels.getSymbol(reelId, 0);
        const symX = sym ? (sym.parent.x + sym.x) : 0;
        const symY = (sym ? (sym.parent.y + sym.y) : 0) + TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_Y;
        return [symX, symY];
    }

    private getBlinkSprite(reelId: number): PIXI.Sprite {
        let sprite = this._blinkFrameArr[reelId];
        if (!sprite) {
            sprite = this.createSprite("frameBlinkShine", true);
            sprite.blendMode = PIXI.BLEND_MODES.ADD;
            const pos: number[] = this.getSymPos(reelId);
            sprite.position.set(pos[0], pos[1] - 36);
            this._blinkFrameArr[reelId] = sprite;
            const layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.PYRAMID.name);
            layer.addChild(sprite);
        }
        return sprite;
    }

    public playNonWinSymBlink() {
        const reelArr: number[] = TombOfAkhenatenGameModuleConfig.reelArr[this._index];
        const tlReelController = (<TOATimelineReelsController>TombOfAkhenaten.timelineReelsController);
        if (this._nonWinSymBlinkTl?.isActive()) {
            this._nonWinSymBlinkTl.pause().kill();
        }
        this._nonWinSymBlinkTl = new TimelineLite();
        const totalBlinkPerPyramid: number = 3;
        const blinkTime = SpinningPyramid.STOP_INTERVAL / totalBlinkPerPyramid;
        for (let blinkCounter = 0; blinkCounter < totalBlinkPerPyramid; blinkCounter++) {
            //blinkTime
            reelArr.forEach((reelId) => {
                if (!tlReelController._stickySymArr[reelId]) {
                    const sprite = this.getBlinkSprite(reelId);
                    this._nonWinSymBlinkTl.add(TweenLite.to(sprite, blinkTime / 2, {
                        alpha: 1,
                        onComplete: () => {
                            TweenLite.to(sprite, blinkTime / 2, {alpha: 0})
                        }
                    }), blinkTime * blinkCounter);
                }
            });
        }

    }

    private playWildAnticipation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => this.addReelFrameFire(this._index * 5 + 0), 0);
        const timeGap: number = 0.633 / 5;
        tl.add(() => this._wildAnticipation.getAnimationAutoShowHide(true, true));
        tl.add(() => {
            if (TombOfAkhenatenGameModuleConfig.spinningPyramidController._isAbort) {
                this.stopFireSweepSound();
            }
            this.playFireSweepSound();
        });
        for (let i = 1; i < 5; i++) {
            tl.add(this.addReelFrameFire(this._index * 5 + i), timeGap * i);
        }
        return tl;
    }

    reset() {
        this._pyramid.tint = 0xffffff;
        this._hotZone.tint = 0xffffff;
        this._ring.tint = 0xffffff;
        this._sky.tint = 0xffffff;

        this._hotZone.angle = 0;
        this._skyGlow.alpha = 0;
        this._hotZoneGlow.alpha = 0;
        this._hotZoneBlast.hide();
        this._pyramidShine.alpha = 0;
        this._pyramidGlow.alpha = 0;
        this._circleShine.alpha = 0;
        this._pyramidShine.alpha = 0;
        this._ringShine.alpha = 0;
        this._isCycleComplete = true;
        SpinningPyramid.reelFireFrameArr.clear();
        this.alpha = 1;
    }

    public hide() {
        this.reset()
        this.visible = false;
    }

    show(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this.visible = true;
        tl.add([
            TweenLite.fromTo(this, 0.001, {alpha: 0}, {alpha: 0.7}), //with 30% transparency
            TweenLite.fromTo(this.scale, 0.3, {x: 0, y: 0}, {x: 1.2, y: 1.2})
        ]);
        tl.add([
            TweenLite.to(this.scale, 0.2, {x: 1, y: 1})
        ]);
        return tl;
    }

    private playLockSound() {
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_LOCK);
    }

    private playFireSweepSound() {
        SoundManager.playSound(TombOfAkhenatenSoundConfig.instance.PW_FIRE_SWEEP);
    }

    private stopFireSweepSound() {
        SoundManager.stopSound(TombOfAkhenatenSoundConfig.instance.PW_FIRE_SWEEP);
    }

    setFullTransparency() {
        TweenLite.to(this, 0.3, {alpha: 1});
    }

    onAbort() {
        if (this._tl?.isActive()) {
            this._tl.progress(1);
        }
    }

    get isHit(): boolean {
        return this._isHit;
    }

    set isHit(value: boolean) {
        this._isHit = value;
    }

}